import type { CreateInvitationResponse } from "@/app/invitations/types";
import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";

export const createProjectInvitation = async ({
  email,
  role,
  scope,
}: {
  email: string;
  role?: string;
  scope: OrgProjectScope;
}): Promise<CreateInvitationResponse> => {
  const client = getCoordinatorApi(scope);
  const { data } = await client.post<CreateInvitationResponse>("/invitations", {
    email,
    // Only sent when RBAC is enabled; the legacy email-only invite is preserved.
    ...(role ? { role } : {}),
  });
  return data;
};
